import React, { useEffect, useState } from 'react';
import './sidebar.css';
import { isAppSettingsPage } from '../routes/dashboardRoutes';

const SPECTRE_LOGO_SRC = (() => {
  const base = String(process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return base ? `${base}/spectre-logo.svg` : '/spectre-logo.svg';
})();

const SPECTRE_LOGO_MARK_SRC = (() => {
  const base = String(process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return base ? `${base}/spectre-logo-mark.svg` : '/spectre-logo-mark.svg';
})();

const iconSize = 20;
const settingsSubIconSize = 17;

const XDR_NAV_PAGES = ['xdr', 'alerts', 'securityEvents'];
const XDR_NAV_ITEMS = [
  { page: 'xdr', label: 'XDR Integrations', iconKey: 'alerts' },
  { page: 'alerts', label: 'Alerts', iconKey: 'alerts' },
  { page: 'securityEvents', label: 'Security Events', iconKey: 'aiIntelligence' },
];

function isXdrNavPage(page) {
  return XDR_NAV_PAGES.includes(page);
}

const SidebarIcons = {
  dashboard: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <path d="M12 2L2 7l10 5 10-5-10-5z" />
      <path d="M2 17l10 5 10-5" />
    </svg>
  ),
  targets: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  ),
  scans: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <line x1="6" y1="18" x2="6" y2="10" />
      <line x1="10" y1="18" x2="10" y2="6" />
      <line x1="14" y1="18" x2="14" y2="8" />
      <line x1="18" y1="18" x2="18" y2="12" />
    </svg>
  ),
  webScans: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  networkScans: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="8.5" y="14" width="7" height="7" rx="1.5" />
      <path d="M6.5 10v2.5A1.5 1.5 0 0 0 8 14h1" />
      <path d="M17.5 10v2.5A1.5 1.5 0 0 1 16 14h-1" />
    </svg>
  ),
  perimeterScans: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <path d="M7.35 18h9.25a3.75 3.75 0 0 0 .55-7.46 5.4 5.4 0 0 0-10.4-1.78A3.45 3.45 0 0 0 7.35 18Z" />
    </svg>
  ),
  earlyDisclosures: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <path d="M5 11h2l1-3h8l1 3h2" />
      <circle cx="7" cy="15" r="4" />
      <circle cx="17" cy="15" r="4" />
      <path d="M11 15h2" />
    </svg>
  ),
  risks: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
      <line x1="4" y1="22" x2="4" y2="15" />
    </svg>
  ),
  alerts: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  aiIntelligence: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <circle cx="12" cy="12" r="3" />
      <path d="M12 1v3M12 20v3M1 12h3M20 12h3M4.93 4.93l2.12 2.12M16.95 16.95l2.12 2.12M19.07 4.93l-2.12 2.12M7.05 16.95l-2.12 2.12" />
    </svg>
  ),
  reports: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  subscription: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  support: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  settings: (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon" aria-hidden="true">
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  /** Settings  Connectors (electrical plug) */
  appSettingsConnectors: (
    <svg
      width={settingsSubIconSize}
      height={settingsSubIconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="sidebar-icon sidebar-icon--settings-sub"
      aria-hidden="true"
    >
      <path d="M12 22v-5" />
      <path d="M9 8V2" />
      <path d="M15 8V2" />
      <path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8" />
    </svg>
  ),
  /** Settings  Deployment (rocket) */
  appSettingsDeployment: (
    <svg
      width={settingsSubIconSize}
      height={settingsSubIconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="sidebar-icon sidebar-icon--settings-sub"
      aria-hidden="true"
    >
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
    </svg>
  ),
  /** Settings  Users & organizations */
  appSettingsUsersOrgs: (
    <svg
      width={settingsSubIconSize}
      height={settingsSubIconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="sidebar-icon sidebar-icon--settings-sub"
      aria-hidden="true"
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  /** Settings  Organizations (building) */
  appSettingsOrganizations: (
    <svg
      width={settingsSubIconSize}
      height={settingsSubIconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="sidebar-icon sidebar-icon--settings-sub"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M9 21V8h6v13" />
      <path d="M9 12h6" />
    </svg>
  ),
  /** Settings  Scan network (routes out to the internet) */
  appSettingsScanNetwork: (
    <svg
      width={settingsSubIconSize}
      height={settingsSubIconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3a14 14 0 0 1 0 18" />
      <path d="M12 3a14 14 0 0 0 0 18" />
    </svg>
  ),
  /** Settings  Sites (map pin) */
  appSettingsSites: (
    <svg
      width={settingsSubIconSize}
      height={settingsSubIconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="sidebar-icon sidebar-icon--settings-sub"
      aria-hidden="true"
    >
      <path d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  ),
  /** Settings  Partners */
  appSettingsPartners: (
    <svg
      width={settingsSubIconSize}
      height={settingsSubIconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="sidebar-icon sidebar-icon--settings-sub"
      aria-hidden="true"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M19 8h4" />
      <path d="M21 6v4" />
    </svg>
  ),
};

const APP_SETTINGS_NAV = [
  { page: 'settingsConnectors', label: 'Connectors', iconKey: 'appSettingsConnectors' },
  { page: 'settingsDeployment', label: 'Deployment', iconKey: 'appSettingsDeployment' },
  { page: 'settingsManageUsers', label: 'Users', iconKey: 'appSettingsUsersOrgs' },
  { page: 'settingsUsersOrgs', label: 'Organizations', iconKey: 'appSettingsOrganizations' },
  { page: 'settingsSites', label: 'Sites', iconKey: 'appSettingsSites' },
  { page: 'settingsScanNetwork', label: 'Scan network', iconKey: 'appSettingsScanNetwork' },
  { page: 'settingsScanNetworkOps', label: 'Scan network ops', iconKey: 'appSettingsScanNetwork' },
  { page: 'settingsPartners', label: 'Partners', iconKey: 'appSettingsPartners' },
];

/** Sidebar: top strip (logo + arrow at seam per mockup), then nav links. */
const Sidebar = ({
  isOpen,
  onClose,
  showMobileClose,
  isCollapsed,
  onToggle,
  activePage,
  activeScanTab = 'web',
  activeScanLocation = 'onprem',
  onSelectPage,
  settingsNavOpen,
  onToggleSettingsNav,
  settingsNavItems,
  defaultSettingsPage,
  showSubscription,
  scansNavOpen,
  onToggleScansNav,
  xdrNavOpen,
  onToggleXdrNav,
}) => {
  const onAppSettings = isAppSettingsPage(activePage);
  const onScansNavPage = activePage === 'scans' || activePage === 'scanDetail';
  const onNetworkScansPage =
    onScansNavPage && activeScanTab === 'network';
  const onXdrNavPage = isXdrNavPage(activePage);
  const showSettingsSub = !isCollapsed && settingsNavOpen;
  const showScansSub = !isCollapsed && scansNavOpen;
  const showXdrSub = !isCollapsed && xdrNavOpen;
  const [networkScansNavOpen, setNetworkScansNavOpen] = useState(onNetworkScansPage);
  const showNetworkScansSub = showScansSub && networkScansNavOpen;
  /* Icon-rail only: keep full wordmark in the mobile drawer even if desktop was collapsed. */
  const showLogoMark = isCollapsed && !showMobileClose;
  const hasSettingsItems = Array.isArray(settingsNavItems) && settingsNavItems.length > 0;

  useEffect(() => {
    if (onNetworkScansPage) setNetworkScansNavOpen(true);
  }, [onNetworkScansPage]);

  const handleSettingsParentClick = () => {
    if (!hasSettingsItems) return;
    if (isCollapsed) {
      onSelectPage(defaultSettingsPage);
      return;
    }
    onToggleSettingsNav();
  };

  const handleScansParentClick = () => {
    if (isCollapsed) {
      onSelectPage('scansWeb');
      return;
    }
    onToggleScansNav();
  };

  const handleNetworkScansParentClick = () => {
    if (isCollapsed) {
      onSelectPage('scansNetwork');
      return;
    }
    if (!networkScansNavOpen) {
      setNetworkScansNavOpen(true);
      if (!onNetworkScansPage) onSelectPage('scansNetwork');
      return;
    }
    setNetworkScansNavOpen(false);
  };

  const handleXdrParentClick = () => {
    if (isCollapsed) {
      onSelectPage('xdr');
      return;
    }
    onToggleXdrNav();
  };

  return (
  <div
    className={`sidebar ${!isOpen ? 'sidebar-closed' : ''} ${isCollapsed ? 'sidebar-collapsed' : ''}`}
    data-tour="sidebar-navigation"
  >
    <div className="sidebar-header">
      {showMobileClose && isOpen ? (
        <button type="button" className="sidebar-mobile-close-btn" onClick={onClose} aria-label="Close menu">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      ) : null}
      <div className={`sidebar-header-brand${isCollapsed ? ' sidebar-header-brand--collapsed' : ''}`}>
        <div className="sidebar-header-logo">
          <img
            src={showLogoMark ? SPECTRE_LOGO_MARK_SRC : SPECTRE_LOGO_SRC}
            alt="xSPECTRE"
            className={`sidebar-header-logo-img${showLogoMark ? ' sidebar-header-logo-img--mark' : ''}`}
          />
        </div>
      </div>
      {!showMobileClose ? (
        <button
          type="button"
          className="sidebar-header-arrow-btn"
          onClick={onToggle}
          aria-label={isCollapsed ? 'Expand menu' : 'Collapse menu'}
          title={isCollapsed ? 'Expand menu' : 'Collapse menu'}
        >
          {isCollapsed ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
          )}
        </button>
      ) : null}
    </div>
    <div className="sidebar-scroll">
    <div className="sidebar-nav">
      <div
        className={`nav-item ${activePage === 'dashboard' ? 'active' : ''}`}
        data-tour="nav-dashboard"
        onClick={() => onSelectPage('dashboard')}
      >
        <span className="nav-icon nav-icon-active">{SidebarIcons.dashboard}</span>
        {!isCollapsed && <span className="nav-label">Security Overview</span>}
      </div>
      <div
        className={`nav-item ${activePage === 'targets' ? 'active' : ''}`}
        data-tour="nav-targets"
        onClick={() => onSelectPage('targets')}
      >
        <span className="nav-icon">{SidebarIcons.targets}</span>
        {!isCollapsed && <span className="nav-label">Assets</span>}
      </div>
      <div className="sidebar-settings-group sidebar-scans-group">
        <div
          role="button"
          tabIndex={0}
          className={`nav-item nav-item-settings-parent ${onScansNavPage ? 'active' : ''}`}
          data-tour="nav-scans"
          onClick={handleScansParentClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleScansParentClick();
            }
          }}
          aria-expanded={isCollapsed ? undefined : showScansSub}
          aria-controls="sidebar-scans-sub"
        >
          <span className="nav-icon">{SidebarIcons.scans}</span>
          {!isCollapsed && (
            <>
              <span className="nav-label">Scans</span>
              <span
                className={`nav-item-settings-chevron ${showScansSub ? 'is-open' : ''}`}
                aria-hidden="true"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="nav-item-settings-chevron-svg"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </>
          )}
        </div>
        {showScansSub ? (
          <div id="sidebar-scans-sub" className="sidebar-settings-sub" role="group" aria-label="Scans">
            <div
              className={`nav-item nav-item-settings-sub ${(activePage === 'scans' || activePage === 'scanDetail') && activeScanTab === 'web' ? 'active' : ''}`}
              role="button"
              tabIndex={0}
              data-tour="nav-scans-web"
              onClick={() => onSelectPage('scansWeb')}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelectPage('scansWeb');
                }
              }}
            >
              <span className="nav-icon nav-icon-settings-sub">{SidebarIcons.webScans}</span>
              <span className="nav-label">Web Scans</span>
            </div>
            <div className="sidebar-scans-network-group">
              <div
                className="nav-item nav-item-settings-sub nav-item-settings-sub-parent"
                role="button"
                tabIndex={0}
                data-tour="nav-scans-network-group"
                onClick={handleNetworkScansParentClick}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleNetworkScansParentClick();
                  }
                }}
                aria-expanded={showNetworkScansSub}
                aria-controls="sidebar-scans-network-sub"
              >
                <span className="nav-icon nav-icon-settings-sub">{SidebarIcons.networkScans}</span>
                <span className="nav-label">Network Scans</span>
                <span
                  className={`nav-item-settings-chevron${showNetworkScansSub ? ' is-open' : ''}`}
                  aria-hidden="true"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="nav-item-settings-chevron-svg"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
              {showNetworkScansSub ? (
                <div
                  id="sidebar-scans-network-sub"
                  className="sidebar-settings-sub sidebar-settings-sub-nested"
                  role="group"
                  aria-label="Network Scans"
                >
                  <div
                    className={`nav-item nav-item-settings-sub${onNetworkScansPage && activeScanLocation !== 'perimeter' ? ' active' : ''}`}
                    role="button"
                    tabIndex={0}
                    data-tour="nav-scans-network"
                    onClick={() => onSelectPage('scansNetwork')}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onSelectPage('scansNetwork');
                      }
                    }}
                  >
                    <span className="nav-icon nav-icon-settings-sub">{SidebarIcons.networkScans}</span>
                    <span className="nav-label">On-premise</span>
                  </div>
                  <div
                    className={`nav-item nav-item-settings-sub${onNetworkScansPage && activeScanLocation === 'perimeter' ? ' active' : ''}`}
                    role="button"
                    tabIndex={0}
                    data-tour="nav-scans-perimeter"
                    onClick={() => onSelectPage('scansPerimeter')}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onSelectPage('scansPerimeter');
                      }
                    }}
                  >
                    <span className="nav-icon nav-icon-settings-sub">{SidebarIcons.perimeterScans}</span>
                    <span className="nav-label">Perimeter</span>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      <div
        className={`nav-item ${activePage === 'earlyDisclosures' ? 'active' : ''}`}
        data-tour="nav-early-disclosures"
        onClick={() => onSelectPage('earlyDisclosures')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelectPage('earlyDisclosures');
          }
        }}
      >
        <span className="nav-icon">{SidebarIcons.earlyDisclosures}</span>
        {!isCollapsed && <span className="nav-label">Early Disclosure</span>}
      </div>
      <div
        className={`nav-item ${activePage === 'risks' || activePage === 'riskDetail' ? 'active' : ''}`}
        data-tour="nav-risks"
        onClick={() => onSelectPage('risks')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelectPage('risks');
          }
        }}
      >
        <span className="nav-icon">{SidebarIcons.risks}</span>
        {!isCollapsed && <span className="nav-label">Vulnerabilities</span>}
      </div>
      <div
        className={`nav-item ${activePage === 'reports' ? 'active' : ''}`}
        data-tour="nav-reports"
        onClick={() => onSelectPage('reports')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelectPage('reports');
          }
        }}
      >
        <span className="nav-icon">{SidebarIcons.reports}</span>
        {!isCollapsed && <span className="nav-label">Reports</span>}
      </div>
      {/* <div
        className={`nav-item ${activePage === 'ocva' ? 'active' : ''}`}
        data-tour="nav-ocva"
        onClick={() => {
          onSelectPage('ocva');
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelectPage('ocva');
          }
        }}
      >
        <span className="nav-icon">{SidebarIcons.aiIntelligence}</span>
        {!isCollapsed && <span className="nav-label">OCVA Assessment</span>}
      </div> */}
    </div>
    <div className="sidebar-bottom">
      {/* <div className="sidebar-settings-group sidebar-xdr-group">
        <div
          role="button"
          tabIndex={0}
          className={`nav-item nav-item-settings-parent ${onXdrNavPage ? 'active' : ''}`}
          onClick={handleXdrParentClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleXdrParentClick();
            }
          }}
          aria-expanded={isCollapsed ? undefined : showXdrSub}
          aria-controls="sidebar-xdr-sub"
        >
          <span className="nav-icon">{SidebarIcons.alerts}</span>
          {!isCollapsed && (
            <>
              <span className="nav-label">XDR</span>
              <span
                className={`nav-item-settings-chevron ${showXdrSub ? 'is-open' : ''}`}
                aria-hidden="true"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="nav-item-settings-chevron-svg"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </>
          )}
        </div>
        {showXdrSub ? (
          <div id="sidebar-xdr-sub" className="sidebar-settings-sub" role="group" aria-label="XDR">
            {XDR_NAV_ITEMS.map(({ page, label, iconKey }) => (
              <div
                key={page}
                className={`nav-item nav-item-settings-sub ${activePage === page ? 'active' : ''}`}
                role="button"
                tabIndex={0}
                onClick={() => onSelectPage(page)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onSelectPage(page);
                  }
                }}
              >
                <span className="nav-icon nav-icon-settings-sub">{SidebarIcons[iconKey]}</span>
                <span className="nav-label">{label}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div> */}

      {/* <div
        className={`nav-item ${activePage === 'aiIntelligence' ? 'active' : ''}`}
        data-tour="nav-ai-intelligence"
        onClick={() => onSelectPage('aiIntelligence')}
      >
        <span className="nav-icon">{SidebarIcons.aiIntelligence}</span>
        {!isCollapsed && <span className="nav-label">AI Intelligence</span>}
      </div> */}

      {hasSettingsItems ? (
      <div className="sidebar-settings-group">
        <div
          role="button"
          tabIndex={0}
          className={`nav-item nav-item-settings-parent ${onAppSettings ? 'active' : ''}`}
          data-tour="nav-settings"
          onClick={handleSettingsParentClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleSettingsParentClick();
            }
          }}
          aria-expanded={isCollapsed ? undefined : showSettingsSub}
          aria-controls="sidebar-settings-sub"
        >
          <span className="nav-icon">{SidebarIcons.settings}</span>
          {!isCollapsed && (
            <>
              <span className="nav-label">Settings</span>
              <span
                className={`nav-item-settings-chevron ${showSettingsSub ? 'is-open' : ''}`}
                aria-hidden="true"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="nav-item-settings-chevron-svg"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </>
          )}
        </div>
        {showSettingsSub ? (
          <div id="sidebar-settings-sub" className="sidebar-settings-sub" role="group" aria-label="Settings">
            {settingsNavItems.map(({ page, label, iconKey }) => (
              <div
                key={page}
                className={`nav-item nav-item-settings-sub ${activePage === page ? 'active' : ''}`}
                data-tour={
                  page === 'settingsConnectors'
                    ? 'nav-settings-connectors'
                    : page === 'settingsDeployment'
                      ? 'nav-settings-deployment'
                      : page === 'settingsManageUsers'
                        ? 'nav-settings-users'
                        : page === 'settingsUsersOrgs'
                          ? 'nav-settings-orgs'
                          : page === 'settingsSites'
                            ? 'nav-settings-sites'
                            : page === 'settingsPartners'
                              ? 'nav-settings-partners'
                              : undefined
                }
                role="button"
                tabIndex={0}
                onClick={() => onSelectPage(page)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onSelectPage(page);
                  }
                }}
              >
                <span className="nav-icon nav-icon-settings-sub">{SidebarIcons[iconKey]}</span>
                <span className="nav-label">{label}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
      ) : null}
      {showSubscription ? (
      <div
        className={`nav-item ${activePage === 'subscription' ? 'active' : ''}`}
        data-tour="nav-subscription"
        onClick={() => onSelectPage('subscription')}
      >
        <span className="nav-icon">{SidebarIcons.subscription}</span>
        {!isCollapsed && <span className="nav-label">Subscription</span>}
      </div>
      ) : null}
      <div
        className={`nav-item ${activePage === 'support' ? 'active' : ''}`}
        data-tour="nav-support"
        onClick={() => onSelectPage('support')}
      >
        <span className="nav-icon">{SidebarIcons.support}</span>
        {!isCollapsed && <span className="nav-label">Support</span>}
      </div>
    </div>
    </div>
  </div>
  );
};

export default Sidebar;
export {
  isXdrNavPage,
  APP_SETTINGS_NAV,
  XDR_NAV_PAGES,
  SidebarIcons,
};


